import { Dataset } from 'generic/dataset'

export const getArticleList = (communityId: string) => {
  const params = [{
    param: 'isActive',
    value: 1,
  }]
  return new Dataset().loadCommunityDataset('communityUpcomingContentPool', communityId, params)
    .then((r1) => {
      const articleList = r1[0].filter((e: any) => e.is_active)
      if (articleList.length === 0) {
        return new Dataset().loadCommunityDataset('communityArticleHistory', communityId, null, 50)
          .then((r2) => r2[0] || [])
      } else {
        return articleList
      }
    })
}